import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const icon: SxStyle = {
  color: (p) => p.palette.grey[400],
};

export const title: SxStyle = {
  fontSize: (p) => p.typography.caption,
  fontWeight: 700,
};

export const degree: SxStyle = {
  fontSize: (p) => p.typography.caption,
  color: (p) => p.palette.common.black,
  fontWeight: 400,
};

export const duration: SxStyle = {
  fontSize: (p) => p.typography.caption,
  fontWeight: 400,
  color: (p) => p.palette.grey[500],
};

export const button: SxStyle = {
  marginTop: (p) => p.spacing(1.5),
  gap: (p) => p.spacing(1),
  fontSize: (p) => p.typography.caption,
  fontWeight: 400,
  color: (p) => p.palette.primary[500],
  borderColor: (p) => p.palette.primary[500],
  backgroundColor: (p) => p.palette.background.paper,
  borderRadius: (p) => p.spacing(0.5),
  width: (p) => p.spacing(19),

  ':hover': {
    background: (p) => p.palette.background.paper,
  },
};
